







import { Component, Vue } from "vue-property-decorator";
import Header from "./components/Header.vue";
import NewsList from "./components/NewsList.vue";

@Component({
  components: {
    Header,
    NewsList
  },
})
export default class Home extends Vue {
  public content: any = "";
}
